import React from "react";
import { Link } from "react-router-dom";

const Forbidden: React.FC = () => (
  <div className="min-h-screen px-6 py-12 flex items-center justify-center">
    <div className="max-w-xl w-full bg-white rounded-lg p-10 border border-border font-body text-ink text-center">
      <p className="text-6xl font-bold font-display text-primary mb-4">403</p>
      <h1 className="text-3xl font-bold font-display mb-4">Forbidden</h1>
      <p className="text-gray-500 mb-8">You do not have permission to view this page.</p>
      <Link
        to="/"
        className="inline-block rounded-lg px-4 py-2 font-semibold font-body text-xl bg-primary text-white hover:bg-ink transition-colors"
      >
        Back to home
      </Link>
    </div>
  </div>
);

export default Forbidden;
